import React from 'react'
import { TranslationConsumer } from 'components/Translation'
import hoistNonReactStatic from 'hoist-non-react-statics'
import { getComponentName } from 'tools/react'

// TODO: Remove the first invocation.
// TODO: Consider rename this Component -> Translate
export default () => (ComposedComponent) => {
  const EnhancedComponent = (props) => (
    <TranslationConsumer>
      {({ t }) => <ComposedComponent {...props} t={t} />}
    </TranslationConsumer>
  )
  hoistNonReactStatic(EnhancedComponent, ComposedComponent)
  EnhancedComponent.displayName = `WithTranslation(${getComponentName(ComposedComponent)})`
  return EnhancedComponent
}
